import { useMediaQuery } from "react-responsive";

export default () => {
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const isTablet = useMediaQuery({ minWidth: 601 });
  const isDesktop = useMediaQuery({ minWidth: 1200 });

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};
